export const getTotalFixedCost = (value) => {
    return {
      type: "GET_TOTAL_FIXED_COST",
      payload: value,
    };
  };